module.exports = "<p>\r\n  page works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/layout/page/page.component.html
// module id = ../../../../../src/app/layout/page/page.component.html
// module chunks = main